import React from 'react';
import useUsersPosts from 'sdk/hooks/useUsersPosts';
import UserVideoView from 'components/shared/UserVideoView';
import styles from './Post.module.scss';

function UserVideos({
  userId,
  exclude,
}: {
  userId: string | number,
  exclude?: number,
}) {
  const postsData = useUsersPosts(userId, 6, exclude)
  // @ts-ignore
  const posts = (postsData?.data || [])

  if (!posts.length) {
    return null
  }

  return (
    <div className={styles.other}>
      <h2>Other</h2>

      <div className={styles.otherVideos}>
        {posts.map((post: any) => (
          <UserVideoView
            key={post?.id}
            data={post}
            size={6}
            min
          />
        ))}
      </div>
    </div>
  )
}

export default UserVideos
